import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["created_date"],
            "sorts": ["desc"]
        },
        "filters": [
        ],
        "pageNo":1,
        "itemsPerPage": 9
    },
    categoryfilter: {
        "listType":"gallery_category",
        "replacements":["%%"]
    },
    locationfilter:{
        "listType":"gallery_location",
        "replacements":["%%"]
    },
    yearfilter: {
        "listType":"gallery_year",
        "replacements":["%%"]
    }
};

const gallerySlice = createSlice({
    name: 'gallery',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateGalleryFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
    updateGalleryFilter
} = gallerySlice.actions;

export default gallerySlice.reducer;
